<template>
  <div class="container-fluid">
    <div class="text-left">
      <div class="row">
        <div class="col-sm-auto">
          <h3 class="font-weight-bolder mt-2">Maintenance Medicines</h3>
        </div>
        <button class="btn btn-outline-primary btn-sm my-auto"
                data-toggle="modal" data-target="#maintenanceMedicines"
                style="opacity: .75">
          <i class="fas fa-plus"></i>
          Add New
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12 text-small text-center">
          <table class="table table-hover table-bordered table-sm">
            <thead class="bg-lightgray">
            <tr>
              <th style="width: 1%">#</th>
              <th>Prescribed Medicine</th>
              <th>Purpose</th>
              <th>Dosage</th>
              <th>Status</th>
              <th>File</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>1</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="width: 10%;">
                <button class="btn btn-outline-info btn-xs mr-1"
                        data-toggle="modal" data-target="#maintenanceMedicines">
                  <i class="fas fa-eye"></i>
                  View
                </button>
                <button class="btn btn-outline-danger btn-xs">
                  <i class="fas fa-trash"></i>
                  Delete
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- View / Add Modal -->
      <div class="modal fade" id="maintenanceMedicines" tabindex="-1" role="dialog" aria-labelledby="maintenanceMedicinesTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="maintenanceMedicinesTitle">Add / Edit Maintenance Medicines</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group row mb-0">
                <label for="prescribedMedicine" class="col-sm-3 col-form-label">Medicine :</label>
                <div class="col-sm-9">
                  <input type="text" id="prescribedMedicine" class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group row mb-0">
                <label for="medicinePurpose" class="col-sm-3 col-form-label">Purpose :</label>
                <div class="col-sm-9">
                  <input type="text" id="medicinePurpose" class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group row mb-0">
                <label for="medicineDosage" class="col-sm-3 col-form-label">Dosage :</label>
                <div class="col-sm-9">
                  <input type="text" id="medicineDosage" class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group row mb-0">
                <label class="col-sm-3 col-form-label">Status :</label>
                <div class="col-sm-9 py-2">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" name="medStatus" id="active" value="active">
                    <label class="form-check-label" for="active">ACTIVE</label>
                  </div>
                </div>
              </div>
              <div class="form-group row mb-0">
                <label for="medFile" class="col-sm-3 col-form-label">File :</label>
                <div class="col-sm-9">
                  <input type="file" id="medFile" class="form-control form-control-sm">
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm mx-1" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary btn-sm mx-1">Add Medicine</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "MaintenanceMedicines"
}
</script>

<style scoped>
.bg-lightgray {
  background: lightgray;
}
table td {
  vertical-align: middle;
}
</style>
